import OLFormatGeoJSON from 'ol/format/GeoJSON'
import OLFormatWKT from 'ol/format/WKT'

export default function (geojson4326) {
  const features = new OLFormatGeoJSON().readFeatures(geojson4326)
  return new OLFormatWKT().writeFeatures(features)
}
